<template>
  <div>
    <div class="container mx-auto my-6 flex items-center gap-2 px-4 leading-none">
      <RouterLink to="/">Главная</RouterLink>
      <span>/</span>
      <RouterLink to="/blog">Информация</RouterLink>
    </div>
    <div class="container mx-auto my-16 px-4">
      <div>
          <button
              class="block"
              type="button"
              @click="openModal('policy')"
          >
              Политика в отношении обработки персональных данных
          </button>
          <button
              class="block"
              type="button"
              @click="openModal('privacy_policy')"
          >
              Политика конфиденциальности
          </button>
          <button
              class="block"
              type="button"
              @click="openModal('personal_data_consent')"
          >
              Согласие на обработку персональных данных
          </button>
          <button
              class="block"
              type="button"
              @click="openModal('terms_of_sale')"
          >
              Условия продажи товаров
          </button>
      </div>
    </div>


  </div>
</template>

<script setup lang="ts">
const router = useRouter()
const openModal = (key: string) => {
    router.push({
        query: {
            ['text_type']: key,
        },
    })
}
</script>
